import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useAuth } from '@ibk/shared-auth';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { Button } from '@ibk/shared-ui';
import { sharedUiTranslations } from '../../translations';
import { Modal } from '../Modal';
import styles from './SessionExpiredModal.module.css';
export const SessionExpiredModalBase = ({ isOpen, onClose, onNavigateToLogin, className, style, 'data-testid': testId = 'session-expired-modal', }) => {
    const { logout } = useAuth();
    const { t } = useTranslation();
    const handleLoginClick = async () => {
        try {
            await logout();
            onNavigateToLogin();
            onClose();
        }
        catch (error) {
            onNavigateToLogin();
            onClose();
        }
    };
    const combinedClassName = [styles.sessionExpiredModal, className].filter(Boolean).join(' ');
    return (_jsx(Modal, { isOpen: isOpen, onClose: onClose, title: t('session-expired.title'), className: combinedClassName, style: style, closeOnBackdropClick: false, showCloseButton: false, "data-testid": testId, children: _jsxs("div", { className: styles.content, children: [_jsx("div", { className: styles.message, children: t('session-expired.message') }), _jsx("div", { className: styles.actions, children: _jsx(Button, { variant: 'primary', size: 'medium', onClick: handleLoginClick, dataTestId: `${testId}-login-button`, className: styles.loginButton, children: t('session-expired.login-button') }) })] }) }));
};
export const SessionExpiredModal = props => {
    return (_jsx(TranslationProvider, { translations: sharedUiTranslations, defaultLanguage: 'pt-BR', children: _jsx(SessionExpiredModalBase, { ...props }) }));
};
export default SessionExpiredModal;
